module.exports = __webpack_public_path__ + "static/media/ве.466f50bd.mp3";